var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-iconstack',{attrs:{"font-scale":"1.2"}},[_c('b-icon',{attrs:{"stacked":"","icon":"folder-fill","variant":"warning"}}),_c('b-icon',{attrs:{"stacked":"","icon":"hdd-fill","variant":"primary","shift-v":"-5","shift-h":"5","scale":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }